import React from "react";
import { Link } from "react-router-dom";
import './scope.css';

function Scope() {
    return (
        <div>
            <div className="scope">
                <h2 className="compTitle">Scope of the Conference</h2>
                <div style={{display: 'flex', justifyContent: 'center', gap: '5vmax'}}>
                    <div>
                        <ul className="scopeList">
                            <li>Rail Dynamics</li>
                            <li>Vehicle Dynamics</li>
                            <li>Probabilistic Models</li>
                            <li>Non-Linear Vibrations</li>
                            <li>Fluid-Structure Interactions</li>
                            <li>Prognostic Health Management</li>
                            <li>MEMS, Smart Structures, and Systems</li>
                            <li>Digital Twinning and Machine Learning</li>
                            <li>Mini Power Trains and Unmanned Vehicles</li>
                            <li>Guidance, Navigation, and Control Technology</li>
                            <li>Condition Monitoring and Machinery Diagnostics</li>
                        </ul>
                    </div>
                    <div>
                        <ul className="scopeList">
                            <li>Rotor Dynamics</li>
                            <li>Wave Propagation</li>
                            <li>Vibration and Waves</li>
                            <li>Flutter and Aero Elasticity</li>
                            <li>Vibration and Acoustic Control</li>
                            <li>Composites and Nano-structures</li>
                            <li>Micro Turbines and Plasma Jet Engines</li>
                            <li>Fracture Fatigue and Damage Mechanics</li>
                            <li>Signal Processing and Parameter Estimation</li>
                            <li>Multi-Physics and Flexible Multi-Body Dynamics</li>
                            <li>Compliant Mechanisms and Topology Optimization</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div style={{ background: '#D1D5DB', padding: '3vmax 5vmax', textAlign: 'center'}}>
                <h3 className="callforabs">Abstracts can be submitted through the <span style={{fontSize: '2.4vmax', textDecoration: 'underline'}}>Springer EquinOCS System</span></h3>
                <div style={{display: 'flex', justifyContent: 'center', gap: '3vmax'}}>
                    <Link to="/abstracts" className="download" style={{textDecoration: 'none', border: 'none', padding: '0.8vmax 2.5vmax', background: '#F6F5F0'}}>Call for Abstracts</Link>
                    <a href="https://equinocs.springernature.com/service/VETOMAC2023" target="_blank" rel="noopener noreferrer" className="download" style={{textDecoration: 'none', border: 'none', padding: '0.8vmax 2.5vmax', background: '#F6F5F0'}}>Submit Abstracts</a>
                </div>
            </div>
        </div>
    )
}

export default Scope;